module.exports = __webpack_public_path__ + "static/media/illustration-embaixadorismo.5ffa26e9.svg";